export default {
  title: "ウェイトリストに参加",
  description:
    "先行体験版にご参加いただき、最新機能をいち早くお試しください。",
  emailPlaceholder: "メールアドレスを入力",
  submitButton: {
    default: "参加する",
    submitting: "送信中...",
  },
  messages: {
    success:
      "ウェイトリストへの登録が完了しました。近日中にご連絡いたします。",
    alreadyExists:
      "すでにウェイトリストに登録されています。最新情報をお届けいたします。",
    error: "送信に失敗しました。後ほど再度お試しください。",
    invalidEmail: "有効なメールアドレスを入力してください。",
    unknownError: "予期せぬエラーが発生しました。後ほど再度お試しください。",
  },
};
